"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantNumberOfNights = void 0;
const getOrderLinesNumberOfNights_1 = require("./getOrderLinesNumberOfNights");
const getVariantNumberOfNights = (variant) => {
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    const hotel_lines = variant.order_lines.filter((orderLine) => {
        return orderLine.type === "HOTEL";
    });
    if (!hotel_lines)
        return 0;
    return (0, getOrderLinesNumberOfNights_1.getOrderLinesNumberOfNights)(hotel_lines);
};
exports.getVariantNumberOfNights = getVariantNumberOfNights;
